import React, { useEffect } from 'react';
import { injectIntl, intlShape } from 'react-intl';

import { passAlongPayerAuthenticationResultData } from 'capi';
import { getTransactionId, getMD } from '../app/bootstrap';
import { getCapiClientFormEncoded } from '../session/sessionSelectors';
import { logError } from '../utils/errorUtils';
import appStore from '../app/appStore';
import paymentMessages from '../payment/paymentMessages';
import LoadingSpinner from '../primitive/LoadingSpinner';

export const PayerAuthenticationStep = ({ intl }) => {
    const passAlongResultData = async (resultData) => {
        try {
            const state = appStore.getState();
            const capiFormEncoded = getCapiClientFormEncoded(state);

            const response = await passAlongPayerAuthenticationResultData(capiFormEncoded, resultData);

            if (response.decision !== 'ACCEPTED') {
                throw new Error(`Error passing along 3DS / PSD2 data: ${response}`);
            }
        } catch (error) {
            
            logError(error);
        }
    };

    useEffect(() => {
        const transactionId = getTransactionId();
        const merchantData = getMD();

        if (transactionId && merchantData) {
            const dataAsJson = {
                TransactionId: transactionId,
                MD: merchantData
            };

            
            
            const formattedData = Object.keys(dataAsJson)
                .map(key => `${key}=${encodeURIComponent(dataAsJson[key])}`).join('&');

            
            passAlongResultData(formattedData);
        }
    }, []);

    const stepUpResultsProps = {
        style: {
            position: 'relative',
            top: '100px',
            left: '-95px',
            width: '260px',
            textAlign: 'center'
        }
    };

    return (
        <div data-testid="payer-auth-step">
            <LoadingSpinner overlay>
                <h2 {...stepUpResultsProps}>
                    { intl.formatMessage(paymentMessages.stepUpResultsMessage) }
                </h2>
            </LoadingSpinner>
        </div>
    );
};

PayerAuthenticationStep.propTypes = {
    
    intl: intlShape.isRequired
};

export default injectIntl(PayerAuthenticationStep);
